import axios from 'axios'

// Axios instance aligned with other services
const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:5000/api',
  headers: { 'Content-Type': 'application/json' },
})

// Attach token if present (keep consistency)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})


const contactService = {
  async submitContact(payload) {
    // payload: { name, email, company, subject, message }
    const response = await api.post('/contact', payload)
    return response.data
  },
}

export default contactService


